
import React, { memo } from 'react';

interface LLMLogoProps {
  name: string;
  src: string;
  alt: string;
}

// Extract individual logo component for memoization
const LogoItem = memo(({ logo }: { logo: LLMLogoProps }) => (
  <div key={logo.name} className="flex flex-col items-center">
    <div className="bg-white p-3 rounded-full shadow-md h-16 w-16 flex items-center justify-center mb-2">
      <img
        src={logo.src}
        alt={logo.alt}
        className="max-h-12 max-w-12 object-contain"
        loading="lazy"
        onError={(e) => {
          console.error(`Failed to load image for ${logo.name}`, e);
          e.currentTarget.src = "https://placehold.co/100x100?text=AI";
        }}
      />
    </div>
    <span className="text-sm font-medium">{logo.name}</span>
  </div>
));

LogoItem.displayName = 'LogoItem';

// Memoize the entire component to prevent unnecessary re-renders
const LLMLogos = memo(() => {
  const llmLogos: LLMLogoProps[] = [
    {
      name: "OpenAI",
      src: "https://static.vecteezy.com/system/resources/previews/021/059/827/non_2x/chatgpt-logo-chat-gpt-icon-on-white-background-free-vector.jpg",
      alt: "OpenAI Logo"
    },
    {
      name: "Claude",
      src: "https://registry.npmmirror.com/@lobehub/icons-static-png/1.44.0/files/dark/claude-color.png",
      alt: "Claude Logo"
    },
    {
      name: "Gemini",
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThr7qrIazsvZwJuw-uZCtLzIjaAyVW_ZrlEQ&s",
      alt: "Gemini Logo"
    },
    {
      name: "DeepSeek",
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqKHD28rGat3WVaqRkRDgIL-SHgOTHB6MrNg&s",
      alt: "DeepSeek Logo"
    },
    {
      name: "Grok",
      src: "https://images.seeklogo.com/logo-png/61/2/grok-logo-png_seeklogo-613403.png",
      alt: "Grok Logo"
    }
  ];

  return (
    <div className="py-10">
      <h3 className="text-xl font-medium text-center mb-8">Access Leading AI Models</h3>
      <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
        {llmLogos.map((logo) => (
          <LogoItem key={logo.name} logo={logo} />
        ))}
      </div>
    </div>
  );
});

LLMLogos.displayName = 'LLMLogos';

export default LLMLogos;
